export default "__VITE_ASSET__ade08a29__"